import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoad = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 16V0H0V16H1ZM16.0006 16V0H15.0006V16H16.0006ZM8.5 16V13.4737H7.5V16H8.5ZM8.5 9.26324V11.7896H7.5V9.26324H8.5ZM8.5 7.5791V5.05279H7.5V7.5791H8.5ZM8.5 0.842337V3.36865H7.5V0.842337L8.5 0.842337Z",
		fill: "currentColor"
	})
});
export default SvgRoad;
